import { HTTPInstanceWithPrefix } from '@/http/http-instance-with-prefix'
import {
  CategoriesResponseModel,
  DishesResponseModel,
  DishModel,
  OrderPayloadModel,
  OrderResponseModel
} from './OrderPageAPI.model'

class OrderPageAPI {
  static getDishCategories = (): Promise<CategoriesResponseModel> =>
    HTTPInstanceWithPrefix.get('/categories').then(response => response.data)

  static getDishes = (): Promise<DishesResponseModel> =>
    HTTPInstanceWithPrefix.get('/dishes').then(response => response.data)

  static getOrders = (tableId: string): Promise<OrderResponseModel> =>
    HTTPInstanceWithPrefix.get(`tables/${tableId}/orders`).then(
      response => response.data
    )

  static postOrder = (payload: OrderPayloadModel): Promise<OrderPayloadModel> =>
    HTTPInstanceWithPrefix.post('/orders', payload).then(
      response => response.data
    )

  static getDish = (dishId: string): Promise<DishModel> =>
    HTTPInstanceWithPrefix.get(`/dishes/${dishId}`).then(
      response => response.data
    )
}

export default OrderPageAPI
